/* unplugin-vue-components disabled */import { render } from "./CreatePlatform.vue?vue&type=template&id=67d890a8&scoped=true&ts=true"
import script from "./CreatePlatform.vue?vue&type=script&lang=ts"
export * from "./CreatePlatform.vue?vue&type=script&lang=ts"

import "./CreatePlatform.vue?vue&type=style&index=0&id=67d890a8&lang=scss"
import "./CreatePlatform.vue?vue&type=style&index=1&id=67d890a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d890a8"]])

export default __exports__